import MicroscopyTemplateThumbnail from "./MicroscopyTemplateThumbnail";
import { updateNestedObject } from './utils';

function getLabelColorFromValue(value){

  let { channelGroup } = value;
  if( channelGroup?.color?.length === 1 ){
    let channelColor = channelColor.color[0];
    return channelColor;
    
  }else{
    return "white";
  }

}

const defaultChannelColors = {
  1:[["red","green","blue"]],
  2:[["green"],["green","blue"]],
  3:[["green"],["blue"],["green","blue"]],
  4:[["red"],["green"],["blue"],["red","green","blue"]],
}

const numBoxes = (s) => s.replaceAll(","," ").split(" ").length;





function getDefaultChannels(structure){
  
  let nodes = structure.replaceAll(","," ").split(" ");
  let { length } = nodes;
  let channelOrder = defaultChannelColors[length];

  let output = Object.fromEntries(channelOrder.map((cs,ii) => ([nodes[ii],cs])));

  return output;


}

const defaultStructure = "A B C D";
const defaultTemplate = {
  channelGroupStructure:defaultStructure,
  channels:getDefaultChannels(defaultStructure),
  regionLocation:"below",
  text:[{ 
    applyAllChannels:{ 
      position:{ base:"tl" }, 
      label:"Label", 
      style:{
        background:"black",
        fontWeight:"bold",
      },
      functions:{ "style.color":"=channelColor" }
    },
  }],
  scalebarLocation:"none",
}





export default function TemplateExpansionTest(){


  let expansion = expand(defaultTemplate);

  return (
    <div class="sg-row">
      <div><pre>{JSON.stringify(defaultTemplate,null,1)}</pre></div>

      <MicroscopyTemplateThumbnail key={Math.random()} template={expansion} templateId={"ti0"} onEvent={(event) => {
      }}/>
    </div>
  )
}

function expand(template){


  
  const INSIDE = "inside";

  
  let { defaultStyleByType={}, channelGroupStructure, regions=[], text=[], scalebar=[], channels={} } = template;

  if( !Array.isArray(channelGroupStructure) ){
    debugger;
  }

  let channelList = channelGroupStructure.flat();//.split(',').map(x => x.split(' ')).flat();

  let rows = channelGroupStructure;//.split(',').map(row => row.trim().split(' '));
  let nodes = {};

  let regionIdList = [];

  nodes.root = {
    d:(rows.length > 1 ? "v" : "h"),
    p:null,
    c:[],
  };


  let regionsByChannel = {};
  regions.forEach((region,ii) => {

    let regionVariableId = "region-"+ii;
    regionIdList.push(regionVariableId);

    for(let channelsToSpecify in region){
      let channelGroupificRegionArgs = region[channelsToSpecify];
      let regionChannelList = channelsToSpecify.split(',');
      
      regionChannelList.forEach(channel => {
        
        let channelNotYetRegistered = !(channel in regionsByChannel);
        if( channelNotYetRegistered ){ regionsByChannel[channel] = {} }

        regionsByChannel[channel][regionVariableId] = channelGroupificRegionArgs

        /* need to introduce the regionOutline nodes */
      })

    }
  })

  //channelList.forEach(channel => { /*add the region outline nodes to each channel region container*/ })

  //** create region outlines for each channel...
  



  rows.forEach((row,iiRow) => {

    let rowContainerId = (rows.length === 1 ? 'root' : 'row-'+iiRow);
    if( !nodes[rowContainerId] ){
      nodes[rowContainerId] = {
        c:[],
        p:'root',
        d:"h" //the row containers are going to be horizontal
      }
    }

    if( rows.length > 1 ){
      nodes.root.c.push(rowContainerId);
    }

    let rowContainer = nodes[rowContainerId];


    let defaultRegionStyle = (
      defaultStyleByType.region || {}
    )

    row.forEach( channel => { 
      let before = []
      let after = [];
      let inside = [];

      let parentId = channel+'-p';
      nodes[parentId] = {
        d:"h",
        p:rowContainerId,
      }

      let channelRegions = regionsByChannel[ channel ] || {};

      
      Object.entries(channelRegions).forEach((regionsEntries,iiRegion) => {

        let [regionVariableId,regionSpec] = regionsEntries;

        let { location, ...regionNodeArgs } = regionSpec;

        let regionNodeId = channel+'-'+iiRegion;

        let regionId = regionVariableId;



        let locationList = ({
          before,
          after,
          below:after,
          above:before,
          inside,
        })[location];

       
        let d = ({
          below:"v",
          above:"v",
          left:"h",
          right:"h",
        })[location] || "h";

        nodes[parentId].d = d;

        if( !locationList ){
          debugger;
        }
        locationList.push( regionNodeId );
       
        let parentToSet = location === INSIDE ? channel : parentId;


        ;
        

        nodes[ regionNodeId ] = {

          type:"region",
          p:parentToSet,
          style:defaultRegionStyle,
          value:{ regionId, channelGroup:channels[channel] },
          ...regionNodeArgs
        }
      })

      
      let c = [...before,channel,...after]

      nodes[ channel ] = {
        type:"region",
        p:parentId,
        style:defaultRegionStyle,
        value:{ regionId:"main",channelGroup:channels[channel] }
      }

      nodes[channel].c = inside
     


      nodes[parentId].c = c;


      if( !rowContainer.c ){
        rowContainer.c = [];
      }
      rowContainer.c.push(parentId);




    })
  })


  function evalTemplateFunctions(functions,nodeId){

    const colorMap = {
      green:"lime",
      blue:"skyblue",
    }

    const BUILTIN_FUNCTIONS = {
      channelColor:() => {

        let channelColors = channels[nodeId];
        if( channelColors.length === 1 ){
          return colorMap[channelColors[0]]||channelColors[0];
        }
        return "white";
      }

    }

    let evaledFuncs = {};
    for(let key in functions){
      let func = functions[key];
      if( func[0] === '=' ){
        let [funcName,funcArgsRaw=""] = func.slice(1).split(':');
        let funcArgs = funcArgsRaw.split(','); 
        evaledFuncs[key] = BUILTIN_FUNCTIONS[funcName](funcArgs)
      }
    }
    return evaledFuncs;
  }

  text.forEach((textItem,iiTextItem) => {
    let { applyAllChannels={}, ...channelGroupificTestArgs } = textItem;

    channelList.forEach(channel => {

      let textBase = textItem.applyAllChannels || {}

      let textNodeId = channel+'-text-'+iiTextItem;

      let channelTextProperties = {
        ...evalTemplateFunctions(textBase.functions,channel),
        ...(channelGroupificTestArgs[channel] || {}),
      }

      // this NULL check is extremely confusing.
      // it comes as 'undefined' and so it adds
      // and I was just thinking for like 30min
      // where does this get processed?
      if( channelTextProperties !== null ){

        let textNode = channelTextProperties ? 
          updateNestedObject(textBase,channelTextProperties)
          : textBase;

        if( !textNode ){ }

        nodes[textNodeId] = textNode
        textNode.type="text";
        textNode.p = channel;
        let channelNode = nodes[channel];
        if( !channelNode.c ){
          channelNode.c = [];
        }
        
        channelNode.c.push(textNodeId);
      }

    })
  })

  


  scalebar.forEach((textItem,iiTextItem) => {
    let { applyAllChannels={}, ...channelGroupificTestArgs } = textItem;


    channelList.forEach(channel => {

      let textBase = textItem.applyAllChannels || {}

      let textNodeId = channel+'-scalebar-'+iiTextItem;

      let channelTextProperties = channelGroupificTestArgs[channel]
      
      if( channelTextProperties !== null ){

        //let evaluatedTextBase = evalTemplateFunctions(textBase);

        let textNode = channelTextProperties ? 
          updateNestedObject(textBase,channelTextProperties)
          : textBase;

        if( !textNode ){
          console.log({channel, textNodeId});
        }

        nodes[textNodeId] = textNode
        textNode.type="scalebar";
        textNode.p = channel;
        let channelNode = nodes[channel];
        if( !channelNode.c ){
          channelNode.c = [];
        }
        
        channelNode.c.push(textNodeId);
      }

    })
  })

  return { nodes, regions:regionIdList, channels };

}


